/**
 * VH-253: one shop aisle and its rows.
 *
 * The heading sticks to the top while its rows scroll, so the answer to "which aisle
 * am I reading?" never leaves the screen mid-list. The aisle keys are the backend's
 * stable ones (produce, dairy, …) and are translated here — an unknown key falls back
 * to "Other" rather than printing a raw key at someone in a shop.
 */

import { useTranslation } from 'react-i18next'
import ShoppingRow from './ShoppingRow'

export default function AisleSection({ group, items, onToggle, onRemove }) {
  const { t } = useTranslation()
  const label = t(`shopping.aisles.${group}`, { defaultValue: t('shopping.aisles.other') })

  return (
    <section className="mb-4" data-testid={`aisle-${group}`}>
      <h2 className="sticky top-0 z-10 bg-surface px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-on-surface-variant">
        {label}
      </h2>
      <ul className="rounded-lg border border-outline-variant bg-surface-container">
        {items.map((item) => (
          <ShoppingRow key={item.id} item={item} onToggle={onToggle} onRemove={onRemove} />
        ))}
      </ul>
    </section>
  )
}
